const COACH = '/c/';
const CHALLENGE_SHARE = '/challenge-share/';

const isCoachRoute = (routePath) => routePath.startsWith(COACH);
const getClientPagePath = (coachId, clientId) => `${COACH}${coachId}/manageClients/${clientId}`;
const getClientMealPlanPagePath = (coachId) => `${COACH}${coachId}/mealPlanner/assignment`;
/** A coach configuration page; `path` is a `configurationPagesConfig[...].path`, or absent for the index. */
const getConfigPagePath = (coachId, path) => `${COACH}${coachId}/config${path ? `/${path}` : ''}`;
/**
 * The workouts tab, optionally deep-linked to one workout. The workout editor is rendered from the
 * tab's own state rather than from a route of its own, so `workoutId` is what lets anything outside
 * the tab — a link, the upload status row — ask it to open a specific workout.
 */
const getWorkoutsPagePath = (coachId, workoutId) => (
  `${COACH}${coachId}/workoutsManager/workouts${workoutId ? `?workoutId=${workoutId}` : ''}`
);

/**
 * The public page a phone opens from the commitment sticker's QR code. It names the challenge only, never the
 * client, so it is safe to show to anyone holding the link.
 */
const getChallengeSharePath = (challengeId) => `${CHALLENGE_SHARE}${challengeId}`;

export {
  isCoachRoute,
  getClientPagePath,
  getClientMealPlanPagePath,
  getConfigPagePath,
  getWorkoutsPagePath,
  getChallengeSharePath,
};
